import { render, staticRenderFns } from "./MoverPedidoModoDialog.vue?vue&type=template&id=438a370a"
import script from "./MoverPedidoModoDialog.vue?vue&type=script&lang=js"
export * from "./MoverPedidoModoDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports